/**
 * Const with params element
 * Block top info component
 * Display a block of last blog or news or other info
 */
/* Import section */
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Ctabuttonwitharrow from "../components/ctabuttonwitharrow"
import "../styles/components/cardarticle.scss"


/* Declaration function */
const Cardarticle = ( { typeArticle, slugTypeArticle, titleArticle, ctaLinkArticle, srcImgArticle} ) => {
  const extLinkArticle = true

  return (
    <div className="card-article card-clickable">
      <div className="box-article">
        <GatsbyImage image={srcImgArticle.localFile.childImageSharp.gatsbyImageData} alt={titleArticle} />
        <div className="content-article">
          <p className="type-article">{typeArticle}</p>
          <h2>{titleArticle}</h2>
          <div className="box-ctatext-card">
            <Ctabuttonwitharrow
            classCta="cta-article"
            ctaLabel="Read Article"
            ctaLink={`https://hellohealth.com/${slugTypeArticle}/${ctaLinkArticle}/`}
            extLink={extLinkArticle} />
          </div>
        </div>
      </div>
      <a href={`https://hellohealth.com/${slugTypeArticle}/${ctaLinkArticle}/`} className="cta-article" aria-label="Read Article" target="_blank" rel="noreferrer"><span className="span-cta-card" >Read Article</span></a>
    </div>
  )
}

/* Export function */
export default Cardarticle

